import React from "react";
import EntryCard from "./EntryCard";
import { useLanguage } from "../../i18n/LanguageContext";

const EntryList = ({ entries, onEditEntry, onDeleteEntry, onSelectEntry }) => {
  const { t } = useLanguage();
  return (
    <div className="grid gap-6">
      {Array.isArray(entries) &&
        entries.map((entry) => (
          <EntryCard
            key={entry.id || entry.entry_id}
            entry={entry}
            onEdit={onEditEntry}
            onDelete={onDeleteEntry}
            onSelect={onSelectEntry}
          />
        ))}
      {(!entries || entries.length === 0) && (
        <p className="text-center text-gray-500 italic">
          {t("journal.empty")}
        </p>
      )}
    </div>
  );
};

export default EntryList;
